import { IEntity } from '@/base/core/iEntity';
export class ProfileModel implements IEntity {
  userName!: any;
  roleID!: any;
  roleName!: any;
  userEmail!: any;
  avatarPath!: any;
  company!: any;
}